import { Component, OnInit } from '@angular/core';
import { TaggingService } from '../../../../Services/Tagging/tagging.service';
import { ActivatedRoute } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-stock-issued-list',
  standalone: true,
  imports: [NgFor, NgIf, FormsModule],
  templateUrl: './stock-issued-list.component.html',
  styleUrl: './stock-issued-list.component.css'
})
export class StockIssuedListComponent implements OnInit {

  issuedList: any[] = [];
  staffId!: number;
  staffName!: string;
  searchText: string = "";
  filterStaffName: string = "";
  filterCategory: string = "";
  pageSize = 10;
  currentPage = 1;

  constructor(
    private taggingService: TaggingService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {


    this.loadIssuedList();
  }

  loadIssuedList() {
    this.taggingService.getAllIssuedStock().subscribe({
      next: (res: any) => {
        this.issuedList = res.data || [];
      },
      error: () => console.error("Failed to fetch issued stock list")
    });
  }
  // loadIssuedList() {
  //   this.taggingService.getIssuedStock(this.staffId).subscribe({
  //     next: (res: any) => {
  //       this.issuedList = res.data || [];
  //     },
  //     error: () => console.error("Failed to fetch issued list")
  //   });
  // }

  paginatedItems() {
    const filtered = this.filteredList();
    const start = (this.currentPage - 1) * this.pageSize;
    return filtered.slice(start, start + this.pageSize);
  }

  get totalPages() {
    return Math.ceil(this.filteredList().length / this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  filteredList() {
    return this.issuedList.filter(item => {

      const matchesSearch =
        !this.searchText ||
        item.std_barcode?.toLowerCase().includes(this.searchText.toLowerCase()) ||
        item.std_item_name?.toLowerCase().includes(this.searchText.toLowerCase());

      const matchesStaff =
        !this.filterStaffName ||
        item.issued_to_name === this.filterStaffName;

      const matchesCategory =
        !this.filterCategory ||
        item.std_item_category === this.filterCategory;

      return matchesSearch && matchesStaff && matchesCategory;
    });
  }
}
